var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 735",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.603 1124.52H464.159L718.42 860.092L972.842 1124.99H1252.36L717.971 569.047L186.603 1124.52Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.36 -389.273H974.767L720.538 -124.841L466.117 -389.74H186.603L720.988 166.204L1252.36 -389.273Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.55 778.714V629.752L1185.45 365.153L1440 100.421V-46.1367L1300.74 -45.5023L905.776 365.621L1300.64 774.707L1439.55 778.714Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.5498 -46.1367V102.859L238.551 367.457L-15.999 632.189V778.714L123.293 778.113L518.257 366.99L123.389 -42.0963L-15.5498 -46.1367Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkDesktop);
export default __webpack_public_path__ + "static/media/watermark-desktop.734c3c33d11d6ea5027f861fd37812af.svg";
export { ForwardRef as ReactComponent };